<div class="row" style="margin-top:75px">
  <div class="col-12">
    <ul class="nav nav-tabs" id="mainTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="entry-tab" data-bs-toggle="tab" data-bs-target="#entry" type="button"
                role="tab" aria-controls="entry" aria-selected="true">
          <i class="fas fa-fw fa-lg fa-clock"></i> Time Entry
        </button>
      </li>
      <li class="nav-item d-none" role="presentation" *ngIf="authUser == impersonatedUser">
        <button class="nav-link" id="calendar-tab" data-bs-toggle="tab" data-bs-target="#calendar" type="button"
                role="tab" aria-controls="calendar" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-calendar"></i> Calendar
        </button>
      </li>
      <!--<li class="nav-item" role="presentation" *ngIf="authUser == impersonatedUser">
        <button class="nav-link" id="calendar2-tab" data-bs-toggle="tab" data-bs-target="#calendar2" type="button"
                role="tab" aria-controls="calendar2" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-calendar"></i> NEW Calendar
        </button>
      </li>-->
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="submitweekly-tab" data-bs-toggle="tab" data-bs-target="#submitweekly" type="button"
                role="tab" aria-controls="submitweekly" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-paper-plane"></i> Submit Weekly Update
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="tasks-tab" data-bs-toggle="tab" data-bs-target="#tasks" type="button" role="tab"
                aria-controls="tasks" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-check"></i> Tasks
        </button>
      </li>

      <li class="nav-item d-none" role="presentation">
        <button class="nav-link" id="settings-tab" data-bs-toggle="tab" data-bs-target="#settings" type="button"
                role="tab" aria-controls="settings" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-user-cog"></i> User Settings
        </button>
      </li>
      <li class="nav-item d-none" role="presentation">
        <button class="nav-link" id="tasks-timemgmt" data-bs-toggle="tab" data-bs-target="#timemgmt" type="button"
                role="tab" aria-controls="timemgmt" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-lock"></i> Time Entry Manager
        </button>
      </li>
      <!--<li class="nav-item" role="presentation" *ngIf="userRole === 1">
    <button class="nav-link" id="review-grid-tab" data-bs-toggle="tab" data-bs-target="#reviewgrid" type="button"
            role="tab" aria-controls="reviewgrid" aria-selected="false">
      <i class="fas fa-fw fa-lg fa-paper-plane"></i> Review Grid
    </button>
  </li>-->
      <li class="nav-item" role="presentation" *ngIf="userRole === 1">
        <button class="nav-link" id="export-tab" data-bs-toggle="tab" data-bs-target="#exportdiv" type="button"
                role="tab" aria-controls="exportdiv" aria-selected="false">
          <i class="fas fa-fw fa-lg fa-lock"></i> Admin Tools
        </button>
      </li>
      <li class="nav-item ms-auto c_bluedk" role="presentation">
        <div class="d-inline-block me-2" *ngIf="(authAdmin == 1)">
          <i class="fas fa-fw fa-user-circle me-2"></i>Viewing As
        </div>
        <div class="d-inline-block" *ngIf="(authAdmin == 1)">
          <select class="form-select form-select-sm" style="width:225px" [(ngModel)]="impersonatedUser"
                  (change)="impersonateUser($event)">
            <option *ngFor="let employee of listEmployees; trackBy: trackByFn" [value]="employee.id">
              {{employee.f_name}} {{employee.l_name}}
            </option>
          </select>
        </div>
        <div class="d-inline-block" *ngIf="(authUser != impersonatedUser)">
          <a class="mx-2 bolder c_red" href="" (click)="killImpersonate()" onclick="return false">Stop</a>
        </div>
      </li>
    </ul>
    <div class="tab-content" id="mainTabsContent">
      <div class="tab-pane fade show active" id="entry" role="tabpanel" aria-labelledby="entry-tab">
        <app-tab-entry (setImpersonateFilter)="setImpersonateFilterValues($event)"></app-tab-entry>
      </div>
      <div class="tab-pane fade" id="calendar" role="tabpanel" aria-labelledby="calendar-tab">
        <app-tab-calendar-multi></app-tab-calendar-multi> <!-- New Calendar Component -->
      </div>
      <div class="tab-pane fade" id="tasks" role="tabpanel" aria-labelledby="tasks-tab">
        <app-tab-tasks-grid></app-tab-tasks-grid>
      </div>
      <div class="tab-pane fade" id="submitweekly" role="tabpanel" aria-labelledby="submitweekly-tab">
        <app-tab-send-weekly-update></app-tab-send-weekly-update>
      </div>
      <!--<div class="tab-pane fade" id="calendar2" role="tabpanel" aria-labelledby="calendar2-tab">
        <app-tab-calendar-multi></app-tab-calendar-multi>--> <!-- New Calendar Component -->
      <!--</div>-->
      <div class="tab-pane fade d-none" id="settings" role="tabpanel" aria-labelledby="settings-tab">
        <app-tab-settings></app-tab-settings>
      </div>
      <!--<div class="tab-pane fade" id="help" role="tabpanel" aria-labelledby="help-tab">
        <app-tab-help></app-tab-help>
      </div>-->
      <!--<div class="tab-pane fade" id="reviewgrid" role="tabpanel" *ngIf="userRole === 1">
        <app-tab-billing-review-grid></app-tab-billing-review-grid>
      </div>
        -->
        <div class="tab-pane fade" id="exportdiv" role="tabpanel" *ngIf="userRole === 1">

        <app-tab-tools></app-tab-tools>
      </div>
    </div>
  </div>
</div>
